import { createRoute, Link, useParams } from '@tanstack/react-router';
import { IconChevronRight } from '@tabler/icons-react';
import { Route as appRoute } from '../../app.js';
import { useCategories } from '../../../hooks/useCategories.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/courses/$category',
  component: CategoryPage,
});

function CategoryPage() {
  const { category } = useParams({ from: '/app/courses/$category' });
  const { data, isLoading } = useCategories();

  if (isLoading) {
    return <div className="text-muted">Loading…</div>;
  }

  const cat = data?.categories.find((c) => c.category === category);

  if (!cat) {
    return (
      <div className="surface p-6">
        <div className="text-sm text-danger">Category not found: {category}</div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl">
      <div className="mb-2 text-xs uppercase tracking-[0.14em] text-muted font-semibold">
        Catalogue
      </div>
      <h1 className="font-serif text-4xl tracking-tighter2 mb-2">{cat.label}</h1>
      <p className="text-muted text-sm mb-8">
        Pick a sub-category to see available courses.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {cat.subCategories.map((sub) => (
          <Link
            key={sub.slug}
            to="/app/courses/$category/$subCategory"
            params={{ category: cat.category, subCategory: sub.slug }}
            className="group surface p-5 flex items-center justify-between hover:border-navy/30 hover:shadow-pop hover:-translate-y-0.5 transition-all duration-200"
          >
            <div>
              <div className="font-serif text-lg text-ink tracking-tightish group-hover:text-navy transition">
                {sub.label}
              </div>
              <div className="text-xs text-muted mt-0.5">{cat.label}</div>
            </div>
            <IconChevronRight size={20} className="text-muted-soft group-hover:text-gold transition" />
          </Link>
        ))}
      </div>
    </div>
  );
}
